import utils from "@/eco-ui-util.js";
import req from "@/request.js";
const portal = req.getContext().portal;
const uc = req.getContext().uc;
const business = req.getContext().business;
export default {
  getSysTypeByCatId(catId) {
    return new Promise(resolve => {
      req
        .request({
          url: `${portal}/sys/sysType/v1/getDataDict?catId=${catId}`
        })
        .then(response => {
          resolve(utils.tile2nest(response.data));
        });
    });
  },
  getTypesByKey(typeKey) {
    return new Promise(resolve => {
      req
        .request({
          url: `${portal}/sys/sysType/v1/getTypesByKey?typeKey=${typeKey}`
        })
        .then(response => {
          resolve(utils.tile2nest(response.data));
        });
    });
  },
  getUserRelByTypeId(typeId) {
    return new Promise(resolve => {
      req
        .request({
          url: `${uc}/api/userRel/v1/userRels/getUserRelByTypeId?typeId=${typeId}`
        })
        .then(response => {
          resolve(utils.tile2nest(response.data));
        });
    });
  },
  // 获取成本科目模板列表
  getCostAccountTemplate(params) {
    return new Promise(resolve => {
      req
        .request({
          url: `${business}/system/cost_account_template_type/query`,
          method: "POST",
          data: params
        })
        .then(response => {
          resolve(response.data);
          // resolve(utils.tile2nest(response.data));
        });
    });
  },
  // 获取默认-1租户成本科目模板列表
  getDefaultCostAccountTemplate(params) {
    return new Promise(resolve => {
      req
        .request({
          url: `${business}/system/cost_account_template_type/defaultList`,
          method: "POST",
          data: params
        })
        .then(response => {
          resolve(response.data);
          // resolve(utils.tile2nest(response.data));
        });
    });
  },
  // 添加成本科目模板
  addCostAccountType(params) {
    return new Promise(resolve => {
      req
        .request({
          url: `${business}/system/cost_account_template_type`,
          method: "POST",
          data: params
        })
        .then(response => {
          console.log(response, 123123);
          // resolve(utils.tile2nest(response.data));
        });
    });
  },
  // 获取成本科目下 科目子集
  getCostAccountTypeChildren(params) {
    return new Promise(resolve => {
      req
        .request({
          url: `${business}/system/cost_account_template/queryByParentId${req.formatGetUri(params)}`,
          method: "POST"
        })
        .then(response => {
          resolve(response.data);
        });
    });
  },
  // 获取成本科目 根据id删除
  delCostAccountType(params) {
    return new Promise(resolve => {
      req
        .request({
          url: `${business}/system/cost_account_template_type/${params}`,
          method: "DELETE"
        })
        .then(response => {
          resolve(response.data);
        });
    });
  },
  // 获取成本科目下 根据id删除
  delCostAccountModule(params) {
    return new Promise(resolve => {
      req
        .request({
          url: `${business}/system/cost_account_template/${params}`,
          method: "DELETE"
        })
        .then(response => {
          resolve(response.data);
        });
    });
  }
};
